import React from 'react';
import HeroSection from '../organisms/HeroSection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      {/* Add more sections here as needed, e.g., features, footer */}
    </div>
  );
};

export default Home;